const isBot = (userAgent?: string) => !!userAgent && /bot/.test(userAgent);

export default isBot;
